<template>
  <div
    v-if="streamURL"
    class="dn-ticker-nc-pulse"
  >
    <div class="container">
      <slot
        class="dn-ticker__prefix"
        name="prefix"
      />
      <div class="item-content">
        <div
          v-for="product in products"
          :key="product?.symbol"
          :class="['item', isDecreased(tickerBuffer[product?.symbol]?.percent) ? 'item-decreased' : 'item-increased']"
        >
          <label
            v-if="tickerBuffer[product?.symbol]?.value"
            class="item-name"
          >
            {{ product?.name }}
          </label>
          <div class="item-holder">
            <span
              v-if="tickerBuffer[product?.symbol]?.value"
              class="item-value"
            >{{ formatPrice(tickerBuffer[product?.symbol]?.value, product?.currency, product?.currencyPosition) }}</span>
            <div
              v-if="isChanged(tickerBuffer[product?.symbol]?.percent)"
              :class="['item-difference-holder', isDecreased(tickerBuffer[product?.symbol]?.percent) ? 'item-difference-holder-decreased' : 'item-difference-holder-increased']"
            >
              <dn-icon
                name="triangle"
                class="icon"
              />
              <span
                v-if="tickerBuffer[product?.symbol].percent"
                :class="['item-difference', 'item-percentage', isDecreased(tickerBuffer[product?.symbol]?.percent) ? 'item-difference-decreased' : 'item-difference-increased']"
              >
                {{ formatChange(tickerBuffer[product?.symbol]?.percent) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <slot
        class="dn-ticker__suffix"
        name="suffix"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  investorTicker: {
    type: Object,
    required: true,
    default: () => {}
  }
});

const streamURL = props.investorTicker.streamURL;
const products = ref(props.investorTicker.products);
const tickerBuffer = ref({});

function formatPrice (price: number, currency: string, currencyPosition: string): string {
  if (currencyPosition === 'B') {
    return price?.toFixed(2) + currency;
  } else {
    return currency + (price ? price.toFixed(2) : '');
  }
}
function formatChange (change: number | null = 0): string {
  return change?.toFixed(2)?.toString() + '%';
}
function isDecreased (change: number | null = 0): boolean {
  return change !== null && change < 0;
}
function isChanged (change: number | null = 0): boolean {
  return change !== null && !(change === 0);
}
function startStreaming () {
  if (import.meta.client && window?.NcPulse) {
    const streamer = new window.NcPulse.OverviewPricesStreamer(streamURL);
    streamer.start((delta: any) => {
      const tempBuffer: any = Object.assign({}, tickerBuffer.value);
      for (const key in delta) {
        tempBuffer[key] = delta[key];
      }
      tickerBuffer.value = tempBuffer;
    });
  }
}
onMounted(() => {
  if (streamURL) {
    useHead({
      script: [{
        key: 'norkon-oil-price-ticker',
        src: `https://stc.dngroup.com/cpp/${useRuntimeConfig()?.public?.name}/js/NcPulse-streaming-2.0.1.min.js`,
        onload: () => {
          startStreaming();
        },
        async: true,
        defer: true
      }]
    });
  }
});
</script>

<style scoped lang="scss">
.dn {
  &-ticker {
    &-nc-pulse {
      --dn_font-size: var(--typography-utility-m-font-size);

      min-height: 51px;

      .container {
        padding-right: 40px;
      }

      .item {
        flex-direction: column;
        padding-right: var(--ui-gap);

        &-name {
          font-weight: 600;
        }

        &-difference {
          &-holder {
            &-increased {
              --dn_color: var(--color-investor-positive-fg);

              svg {
                fill: var(--color-investor-positive-fg);
              }
            }

            &-decreased {
              --dn_color: var(--color-investor-negative-fg);

              svg {
                transform: rotate(180deg);
                fill: var(--color-investor-negative-fg);
              }
            }
          }
        }
      }
    }
  }
}
</style>
